import { Close, Search } from "@mui/icons-material"
import { IconButton, InputAdornment, TextField } from "@mui/material"
import { type ChangeEvent, type FC, forwardRef, useState } from "react"

import type { SearchFieldProps } from "./search-field.types"

export const SearchField: FC<SearchFieldProps> = forwardRef(
	(
		{
			size,
			onClear,
			onValueChange,
			clearBtnId = "clear-btn",
			initialValue = "",
			...props
		},
		ref,
	) => {
		const [value, setValue] = useState(initialValue)

		const onChange = (event: ChangeEvent<HTMLInputElement>) => {
			setValue(event.target.value)
			onValueChange?.(event.target.value)
		}

		const handleClose = () => {
			setValue("")
			onClear?.()
		}

		return (
			<TextField
				ref={ref}
				{...props}
				size={size}
				value={value}
				autoComplete='off'
				onChange={onChange}
				InputProps={{
					endAdornment: (
						<InputAdornment position='end'>
							{value ? (
								<IconButton
									edge='end'
									size='small'
									onClick={handleClose}
									data-testid={clearBtnId}
								>
									<Close />
								</IconButton>
							) : (
								<Search />
							)}
						</InputAdornment>
					),
				}}
			/>
		)
	},
)
